import React, { useState } from "react";
import { FiSettings } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import ResumeCard from "./ResumeCard";

function PositionTable({ advanceData, setDataShowCom, setFormData, emailSendModal, setSelectedIds, selectedIds }) {
  console.log(advanceData);

  const location = useLocation();
  // const advanceData = location?.state?.advanceData || [];
  // console.log('advanceData', advanceData);
  const backToSerc = () => {
    setDataShowCom(true)

    setFormData({
      name: '',
      mobile: '',
      email: '',
      job_category: '',
      location: '',
      status: '',
      gender: '',
      min_salary: '',
      max_salary: '',
      min_experience: '',
      max_experience: '',
      keyword: '',
      start_date: '',
      end_date: '',
      and_operator: false,


      keywords: '',
      exclusiveKeywords: '',
      itSkills: '',
      experienceFrom: '',
      experienceTo: '',
      currentLocation: '',
      salaryFrom: '',
      salaryTo: '',
      age: '',
      name: '',
      email: '',
      date_of_Birth: '',
      country: '',
      state: '',
      city: '',
      nationality: '',
      gender: '',
      // mobile: '',
      careerLevel: '',
      industry: '',
      functionalArea: '',
      jobExperience: '',
      expectedSalary: '',
      currentSalary: '',
      salaryCurrency: '',
      boolean: false,
    })
  }

  // console.log(selectedIds);


  const handleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };


  const handleSelectAll = () => {
    if (
      selectedIds.length === (advanceData?.data?.length || 0)
    ) {
      setSelectedIds([]);
    } else {
      setSelectedIds(advanceData?.data?.map((resume) => resume.email || resume.email));
    }
  };


  return (
    <div className="pageTable">
      <div className="tableLength">
        <div className="dataTables_length d-flex justify-content-between pageHeader" style={{ padding: "6px 0" }}>
          <div className="pageTitle">
            <FiSettings />
            <h5>Resume List</h5>
          </div>
          <div>
            <button className="btn btn-primary me-3" onClick={emailSendModal}>Send Mail</button>
            <button className="btn btn-primary" onClick={backToSerc}>Back To Search</button>
            {/* <select className="form-select">
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
            </select>
            <span className="record">records</span> */}
          </div>
        </div>
      </div>
      <div>
        {Array.isArray(advanceData?.data) && advanceData.data.length > 0 && (
          <input
            type="checkbox"
            onChange={handleSelectAll}
            checked={
              selectedIds.length === (advanceData?.data?.length || 0)
            }
            className="me-2"
          />
        )}
        All Select
      </div>

      {Array.isArray(advanceData?.data) && advanceData?.data?.length > 0 ? (
        advanceData?.data?.map((resume) => {
          // console.log(resume);
          return <div key={resume._id} className="d-flex justify-content-between gap-2">
            {/* Checkbox before the card */}
            <input
              type="checkbox"
              checked={selectedIds.includes(resume.email)}
              onChange={() => handleSelect(resume.email)}
            />

            {/* Resume card */}
            <ResumeCard resume={resume} />
          </div>

          // <ResumeCard key={resume._id || resume.id} resume={resume} />;
        })
      ) : (
        alert('No Data Found')
      )}
      {/* {data?.map((resume) => (
        <ResumeCard resume={resume} />
      ))} */}
    </div>
  );
}

export default PositionTable;
